<script setup lang="ts">
  import { ref, watch } from 'vue'
  import { Select, SelectOption } from 'ant-design-vue'
  import { useWindowSize } from '@/composables/useWindowSize'

  interface IArrayValuesCalculationConfigurationProps {
    modelValue: string[]
    placeHolder: string
  }

  const props = defineProps<IArrayValuesCalculationConfigurationProps>()
  const emit = defineEmits<{ 'update:modelValue': [value: string[]] }>()

  const values = ref<string[]>([...props.modelValue])

  watch(
    () => props.modelValue,
    (newVal) => {
      values.value.splice(0, values.value.length, ...newVal)
    },
    { deep: true }
  )

  watch(
    values,
    (newVal) => {
      emit('update:modelValue', [...newVal])
    },
    { deep: true }
  )

  const { controlSize } = useWindowSize()
</script>

<template>
  <div class="array-values-calculation-config">
    <Select
      v-model:value="values"
      mode="tags"
      :open="false"
      :placeholder="props.placeHolder"
      :size="controlSize"
      class="w-full"
      showSearch
      allowClear
    >
      <SelectOption v-for="value in values" :key="value" :value="value">
        {{ value }}
      </SelectOption>
    </Select>
  </div>
</template>

<style scoped>
  .array-values-calculation-config {
    display: flex;
    flex-direction: column;
  }
  .tag {
    margin-bottom: 4px;
  }
</style>
